import { MouseEvent, useState } from 'react';
import useLocales from 'src/hooks/useLocales';

export const useLanguageSelector = () => {
  const { allLang, currentLang, onChangeLang } = useLocales();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handelChangeLang = (newLang: string): void => {
    onChangeLang(newLang);
    handleClose();
  };

  return {
    allLang,
    currentLang,
    onChangeLang,
    anchorEl,
    handelChangeLang,
    handleOpen,
    handleClose,
  };
};
